import { NotificationService } from '../../services/notification.service'; // NotificationService;

/** Shared toast config for invoice download success. */
export const INVOICE_DOWNLOAD_SUCCESS_TOAST = {
  severity: 'success' as const,
  summary: 'Invoice saved to device!',
  detail: 'The invoice has been downloaded to your device.',
};

/** Shared toast config for invoice download error. */
export const INVOICE_DOWNLOAD_ERROR_TOAST = {
  severity: 'error' as const,
  summary: 'Download failed',
  detail: 'There was an error generating the invoice. Please try again.',
};

export function showInvoiceDownloadSuccess(messageService: NotificationService): void {
  setTimeout(() => messageService.add(INVOICE_DOWNLOAD_SUCCESS_TOAST), 100);
}

export function showInvoiceDownloadError(messageService: NotificationService): void {
  messageService.add(INVOICE_DOWNLOAD_ERROR_TOAST);
}

/**
 * Run an invoice generation function and show success or error toast.
 * Use in customer-tab-view, super-admin-order-details-modal, etc.
 */
export function runInvoiceDownloadAndNotify(
  messageService: NotificationService,
  generateFn: () => void
): void {
  try {
    generateFn();
    showInvoiceDownloadSuccess(messageService);
  } catch (error) {
    showInvoiceDownloadError(messageService);
  }
}
